import {compose} from 'redux';
import {withRouter} from 'react-router-dom';
import withNextStep from "../../components/hoc/withNextStep";
import Step10 from './Step10-redux';

export default compose(
  withRouter,
  withNextStep
)(Step10);
